var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-box",
    {
      attrs: {
        title: _vm.title,
        icon: "eye",
        "is-processing": _vm.isProcessing,
        "is-visible": _vm.isVisible,
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "a",
                {
                  staticClass: "gfu-link gfu-link--accent",
                  attrs: { href: "", "data-qa": "modal-button:Cancel" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("close")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.text
        ? _c("p", { attrs: { "data-qa": "modal-text" } }, [
            _vm._v(_vm._s(_vm.text)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "gfu-grid _mb-6" }, [
        _c(
          "div",
          { staticClass: "gfu-grid__cell gfu-2of3" },
          [
            _c("text-field", {
              ref: "input",
              attrs: {
                "display-name": _vm.displayName,
                "show-label": _vm.showLabel,
                "read-only": false,
                "data-qa": "modal-field:DigitalCode",
              },
              model: {
                value: _vm.secretValueDisplay,
                callback: function ($$v) {
                  _vm.secretValueDisplay = $$v
                },
                expression: "secretValueDisplay",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "gfu-grid__cell gfu-1of3 _pl-1",
              _vm.showLabel ? "_pt-6" : "_pt-3",
            ],
          },
          [
            !_vm.isShowingSecretValue
              ? _c(
                  "icon-base-button",
                  {
                    attrs: {
                      theme: "accent",
                      icon: "eye",
                      "data-qa": "modal-button:Show",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggleSecretValue.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("show")]
                )
              : _c(
                  "icon-base-button",
                  {
                    attrs: {
                      theme: "accent",
                      icon: "eye",
                      "data-qa": "modal-button:Hide",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggleSecretValue.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("hide")]
                ),
            _vm._v(" "),
            _vm.isShowingSecretValue
              ? _c(
                  "icon-base-button",
                  {
                    attrs: {
                      theme: "accent",
                      icon: "copy",
                      "data-qa": `modal-button:${
                        _vm.secretValueCopied ? "Copied" : "Copy"
                      }`,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.copySecretValue.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.secretValueCopied ? "copied!" : "copy"))]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }